module.exports = __webpack_public_path__ + "img/LogoNO-type.hvid.a4bb6d9b.png";